var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"card-info"},[_c('div',{staticClass:"card"},[_c('avue-data-progress',{attrs:{"option":_vm.option}}),_c('avue-data-tabs',{staticStyle:{"margin-top":"30px"},attrs:{"option":_vm.option3}})],1),_c('div',{staticClass:"card-right"},[_c('avue-data-box',{attrs:{"option":_vm.option2}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }